import { render, staticRenderFns } from "./project-file.vue?vue&type=template&id=6fb668fc&scoped=true&"
import script from "./project-file.vue?vue&type=script&lang=js&"
export * from "./project-file.vue?vue&type=script&lang=js&"
import style0 from "./project-file.vue?vue&type=style&index=0&id=6fb668fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb668fc",
  null
  
)

export default component.exports